import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import QuestionGroupFields from './QuestionGroupFields'

export const QuestionGroupCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <QuestionGroupFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default QuestionGroupCreate
